"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const with_result_1 = require("./with-result");
const partition_results_1 = require("./partition-results");
const ResultIs = {
    success: (...args) => {
        console.warn("ResultIs.success is deprecated and will be removed in a later update. Use ok instead.");
        return _1.ok(...args);
    },
    failure: (...args) => {
        console.warn("ResultIs.failure is deprecated and will be removed in a later update. Use err instead.");
        return _1.err(...args);
    }
};
if (typeof window !== "undefined") {
    window.err = _1.err;
    window.ok = _1.ok;
    window.ResultIs = ResultIs; // For backwards compatibility
    window.withResult = with_result_1.withResult;
    window.partitionResults = partition_results_1.partitionResults;
}
else {
    globalThis.err = _1.err;
    globalThis.ok = _1.ok;
    globalThis.ResultIs = ResultIs; // For backwards compatibility
    globalThis.withResult = with_result_1.withResult;
    globalThis.partitionResults = partition_results_1.partitionResults;
}
